import React, { useContext } from 'react';
import SearchBar from '../../basic/SearchBar';
import { ThematicPackagePageCtx } from '../../../pages/ThematicPage';

const ThematicPackageSearchBar = (_props) => {
  const { search, setSearch } = useContext(ThematicPackagePageCtx);

  const onChange = (value) => {
    setSearch(value);
  };

  return (
    <SearchBar
      placeholder='Search in Thematic Packages'
      value={ search }
      onChange={ onChange }
    />
  );
};

export default ThematicPackageSearchBar;
